import { parseProductDataObj, pushSelectItem } from "../../../helpers/pushSelectItem";

const test = ({ target }) => target.closest(".comparator a");

const push = ({ target }) => {
  const dataObj = parseProductDataObj(target);
  if (!dataObj.item_id) return;

  pushSelectItem(dataObj);
};

export default {
  name: "comparatorLink",
  test,
  push,
};
